__turbopack_context__.v({
  "antContent": "InvoiceModal-module-scss-module__XSyVja__antContent",
  "closeIcon": "InvoiceModal-module-scss-module__XSyVja__closeIcon",
  "modalTitle": "InvoiceModal-module-scss-module__XSyVja__modalTitle",
});
